module.exports = __webpack_public_path__ + "img/19.040ba5c7.png";